import axios from 'axios';

/**
 * Service for managing TOML files in GitHub repository
 */
export class GitHubService {
  static XPAD_TOML_API = 'https://www.xpad.space/api/generate-toml';
  
  // Add alternative API endpoint as fallback
  static ALTERNATE_TOML_API = 'https://api.xrpl.services/token-toml';
  
  /**
   * Generate a TOML file and host it on GitHub Pages
   */
  static async generateTomlFile(tokenData) {
    try {
      // First try the primary API
      try {
        console.log('Attempting to generate TOML using primary API endpoint...');
        const response = await axios.post(this.XPAD_TOML_API, tokenData);
        console.log('TOML file generated successfully with primary API');
        return response.data;
      } catch (primaryApiError) {
        console.warn('Primary TOML API failed:', primaryApiError.message);
        
        // If primary API fails with 500 error, try the fallback API
        if (primaryApiError.response && primaryApiError.response.status === 500) {
          console.log('Attempting to use fallback TOML API...');
          
          // Adjust data format if needed for the alternate API
          const formattedData = {
            ...tokenData,
            token: {
              name: tokenData.name,
              symbol: tokenData.symbol,
              issuer: tokenData.issuer,
              domain: tokenData.domain || 'xpad.space',
              description: tokenData.description || `${tokenData.name} token created with XPad`,
            }
          };
          
          try {
            const fallbackResponse = await axios.post(this.ALTERNATE_TOML_API, formattedData);
            console.log('TOML file generated successfully with fallback API');
            return fallbackResponse.data;
          } catch (fallbackError) {
            console.error('Fallback TOML API also failed:', fallbackError.message);
            
            // If both APIs fail, generate a local TOML only
            console.log('All remote TOML services failed, proceeding with local TOML only');
            return { 
              success: false, 
              hostedUrl: null,
              message: 'Remote TOML services unavailable, proceeding with local TOML only'
            };
          }
        }
        
        // Rethrow if it's not a 500 error that we can handle
        throw primaryApiError;
      }
    } catch (error) {
      console.error('Error generating TOML file:', error);
      
      // Return a structured error response instead of throwing
      return {
        success: false,
        error: error.message,
        hostedUrl: null,
        fallbackMode: true,
        message: 'TOML hosting service unavailable. Proceeding with local TOML file only.'
      };
    }
  }
  
  /**
   * Get raw TOML content for a token
   * @param {Object} tokenData - Token data
   * @returns {Promise<string>} - TOML file content
   */
  async getTomlContent(tokenData) {
    try {
      const response = await axios.post('/api/toml-content', tokenData);
      
      if (response.data && response.data.content) {
        return response.data.content;
      }
      
      throw new Error('Failed to get TOML content from response');
    } catch (error) {
      console.error('Error getting TOML content:', error);
      throw error;
    }
  }
}

const githubService = new GitHubService();
export default githubService; 